import { Link } from "react-router-dom";
import { gkCategories } from "@/mocks/categories";
import type { GkArticle } from "@/mocks/news";

export function categoryName(slug: string) {
  return gkCategories.find((c) => c.slug === slug)?.name || slug;
}

export function formatDate(date: string) {
  return date.replace(/-/g, "/");
}

export function GkCard({ article, imgClass = "aspect-[4/3]" }: { article: GkArticle; imgClass?: string }) {
  const catName = categoryName(article.category);
  return (
    <article className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50">
      <Link to={`/news/${article.id}`} aria-label={article.title} className="block overflow-hidden">
        <div className={`relative overflow-hidden ${imgClass}`}>
          <img
            src={article.cover}
            alt={article.title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {article.hot && (
            <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
              <i className="ri-fire-fill"></i>热
            </span>
          )}
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="mb-2 flex items-center gap-2 text-xs text-foreground-500">
          <span className="text-primary-600">{catName}</span>
          <span className="h-3 w-px bg-background-300"></span>
          <span>{article.date}</span>
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
          <Link to={`/news/${article.id}`}>{article.title}</Link>
        </h3>
        <p className="mt-2 hidden text-sm leading-6 text-foreground-600 sm:block">{article.summary}</p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{article.views}</span>
          <span className="flex items-center gap-1 text-accent-700"><i className="ri-arrow-right-line"></i>查看瓜料</span>
        </div>
      </div>
    </article>
  );
}

export function GkRowCard({ article }: { article: GkArticle }) {
  const catName = categoryName(article.category);
  return (
    <article className="group flex flex-col gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 sm:flex-row sm:items-center">
      <Link to={`/news/${article.id}`} aria-label={article.title} className="block shrink-0 overflow-hidden sm:w-56">
        <img src={article.cover} alt={article.title} className="aspect-[3/2] w-full rounded-xl object-cover transition-transform duration-500 group-hover:scale-105" />
      </Link>
      <div className="min-w-0 flex-1">
        <div className="mb-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="text-primary-600">{catName}</span>
          {article.tags.slice(0, 2).map((t) => (
            <span key={t} className="rounded-full bg-background-100 px-2 py-0.5 text-foreground-600">{t}</span>
          ))}
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
          <Link to={`/news/${article.id}`}>{article.title}</Link>
        </h3>
        <p className="mt-1.5 line-clamp-2 text-sm text-foreground-600">{article.summary}</p>
        <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{article.views}</span>
          <span className="flex items-center gap-1"><i className="ri-calendar-line"></i>{article.date} {article.time}</span>
        </div>
      </div>
    </article>
  );
}